<template>
  <div class="modelling-model-list">
    <el-row type="flex" justify="space-between" align="middle" v-if="model">
      <div class="modelling-model-list__title">Модель:</div>
      <el-tooltip
        :open-delay="500"
        effect="dark"
        content="Настройки моделирования"
        placement="top"
      >
        <el-button
          @click="openModalBox('modelling-settings')"
          class="r-button"
          size="mini"
          icon="el-icon-s-tools"
          circle/></el-tooltip
    ></el-row>
    <el-select
      class="r-select dark"
      placeholder="Выберите модель"
      v-model="model"
      @change="changeModel"
      size="mini"
    >
      <el-option
        v-for="item in models"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  props: ["models"],
  data() {
    return {
      model: ""
    };
  },
  methods: {
    changeModel(id) {
      const model = this.models.find(m => m.id === id);
      this.$emit("change-model", { id, model });
    },
    openModalBox(val) {
      this.$store.commit("OPEN_MODAL_WINDOW", val);
    }
  }
};
</script>

<style lang="scss">
.modelling-model-list {
  padding: 10px;
  &__title {
    font-size: 12px;
    color: rgba(var(--white_white), 0.6);
  }
  .r-select {
    width: 100%;
  }
  .r-button {
    font-size: 18px;
    padding: 1px;
    background: none !important;
    border: none !important;
    color: var(--text_secondary) !important;
    &:hover {
      opacity: 1;
      color: var(--accent_primary) !important;
    }
  }
}
</style>
